import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { environment } from "../../shared/config/environment";

const initialState = {
  data: {},
  name: null,
  email: null,
  otp: "",
  phone: "",
  newPhone: "",
  otpData: {},
  status: false,
  error: "",
  otpMessage: "",
  otpStatus: false,
  verifyMessage: "",
  errorStatus: false,
  currentTenant: "",
  flavor: "",
  loading:false
};

export const fetchOtp = createAsyncThunk("userProfile/getOtp", async (data) => {

  try {
    var config = {
      method: "POST",
      url: environment.URL + "auth/user-profile",
      headers: {
        "Content-Type": "application/json",
        //"X-Tenant": tenant_id,
      },
      data: data,
    };
    const response = await axios(config);


    return response.data;
  } catch (error) {
    throw error;
  }
});

export const editUserName = createAsyncThunk(
  "userProfile/editUserName", async (data, { rejectWithValue }) => {
    try {
      var config = {
        method: "PUT",
        url: environment.URL + `auth/update-username`,
        headers: {
          "Content-Type": "application/json",
          //"X-Tenant": tenant_id,
        },
        data: data,
      };
      const response = await axios(config);


      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
)

export const verifyEmail = createAsyncThunk(
  "userProfile/verifyEmail",
  async (data, { rejectWithValue }) => {
    try {
      var config = {
        method: "PUT",
        url: environment.URL + `auth/user-verify`,
        headers: {
          "Content-Type": "application/json",
          //"X-Tenant": tenant_id,
        },
        data: data,
      };
      const response = await axios(config);


      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const verifyPhone = createAsyncThunk(
  "userProfile/verifyPhone",
  async (data, { rejectWithValue }) => {
    try {
      var config = {
        method: "PUT",
        url: environment.URL + `auth/user-verify`,
        headers: {
          "Content-Type": "application/json",
          //"X-Tenant": tenant_id,
        },
        data: data,
      };
      const response = await axios(config);


      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const userSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    updateName(state, action) {
      state.name = action.payload;
    },
    updateEmail(state, action) {

      state.email = action.payload;
    },
    updateOtp(state, action) {

      state.otp = action.payload;
    },
    updatePhone(state, action) {
      state.newPhone = action.payload;
    },
    chanageNewPhone(state, action) {
      state.newPhone = action.payload;
    },
    initUpdate(state, action) {
      state.data = action.payload;
      state.name = action.payload.name
      state.email = action.payload?.email;
      state.phone = action.payload.phone;
    },
    resetStatus(state, action) {
      state.status = false;
      state.otpStatus = false;
      state.otpMessage = "";
      state.verifyMessage = "";
      state.loading = false;
    },
    resetError(state, action) {
      state.error = "";
      state.errorStatus = false;
    },
    insertUser(state, action) {
     
      state.data = action.payload;
      state.currentTenant = action.payload?.currentTenant;
      state.flavor = action.payload?.flavor;
    },
    resetUser: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(fetchOtp.pending,(state,action)=>{
        state.loading = true
      })
      .addCase(fetchOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.otpData = action.payload;
        state.otpStatus = true;
        state.otpMessage = action.payload.message;
      })
      .addCase(fetchOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = "Error while fetch otp ,Please try again later";
      })
      .addCase(verifyEmail.pending,(state,action)=>{
        state.loading = true;
      })
      .addCase(verifyEmail.fulfilled, (state, action) => {
        const user = action.payload?.user;
        const userData = {
          "id": user?.id,
          "name": user?.name,
          "phone": user?.phone,
          "currentTenant": state.currentTenant,
          "email": user?.email,
          "flavor": state.flavor,
        }
        state.loading = false;
        state.data = userData;
        state.status = true;
        state.verifyMessage = "Email updated successfully";
      })
      .addCase(verifyEmail.rejected, (state, action) => {
        state.loading = false;
        state.status = false;
        state.errorStatus = true;
        state.error = action.payload.error;
      })
      .addCase(verifyPhone.pending,(state,action)=>{
        state.loading = true;
      })
      .addCase(verifyPhone.fulfilled, (state, action) => {
        const user = action.payload?.user;
        const userData = {
          "id": user?.id,
          "name": user?.name,
          "phone": user?.phone,
          "currentTenant": state.currentTenant,
          "email": user?.email,
          "flavor": state.flavor,
        }
        state.loading = false;
        state.data = userData;
        state.status = true;
        state.verifyMessage = "Phone updated successfully";
      })
      .addCase(verifyPhone.rejected, (state, action) => {
        state.loading = false;
        state.status = false;
        state.errorStatus = true;
        state.error = action.payload.error;
      })
      .addCase(editUserName.fulfilled, (state, action) => {
        const user = action.payload?.user;
        const userData = {
          "id": user?.id,
          "name": user?.name,
          "phone": user?.phone,
          "currentTenant": state.currentTenant,
          "email": user?.email,
          "flavor": state.flavor,
        }
        state.data = userData;
        state.status = true;
        state.verifyMessage = action.payload.message;
      })
      .addCase(editUserName.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload.error;
      })
  },
});

export const {
  updateName,
  updateEmail,
  updateOtp,
  updatePhone,
  initUpdate,
  resetStatus,
  resetUser,
  chanageNewPhone,
  resetError,
  insertUser,
} = userSlice.actions;

export default userSlice.reducer;
